import { AbstractTextItem } from "./AbstractTextItem";
import { ITextLengthValidatable } from "./ITextLengthValidatable";

export abstract class AbstractRichTextItem extends AbstractTextItem implements ITextLengthValidatable {
  constructor(typeKey: string, value: any) {
    super(typeKey, value);
  }

  /** 文字の長さチェック */
  public enableLengthCheck: boolean;
  public lengthChecklength: number;

  protected applyMembers(clone: AbstractRichTextItem): void {
    super.applyMembers(clone);
    clone.enableLengthCheck = this.cloneValue(this.enableLengthCheck);
    clone.lengthChecklength = this.cloneValue(this.lengthChecklength);
  }

  public abstract get plainText(): string;
  public abstract set plainText(text: string);

  public abstract getTextLength(): number;

  public getDisplayName(): string {
    return this.name;
  }

  text(): string {
    // TODO: plainText相当の実装が可能か見直し
    return this.plainText;
  }

  // value(string/number)をそのまま検証対象とする場合はこのままでOK
  // value以外の値やvalueをstring/number以外として扱う場合は、派生クラスでオーバーライドする事
  protected valueToText(value: any): string {
    switch (typeof value) {
      case "string":
        return value;
      case "number":
        return value + "";
      default:
        return "";
    }
  }
}
